export const environment = {
    production: true,
    showTelemetry: false,
    apiToken: 'IhmLy3Au1k3y',
    transcriptUrl: 'https://lyra-ui-connector.prognplay-ihm.com/api/transcription/v2',
    streamUrl: 'https://lyra-ui-connector.prognplay-ihm.com/api/streaming/v2',
    stationUrl: 'https://lyra-ui-connector.prognplay-ihm.com/api/streaming/v2',
    downloadsUrl: 'https://lyra-ui-connector.prognplay-ihm.com/api/ui-svc/v1',
    subscriptionsUrl: 'https://lyra-ui-connector.prognplay-ihm.com/api/ui-svc/v1',
    audioSubscriptionsUrl: 'https://lyra-ui-connector.prognplay-ihm.com/api/ui-svc/v1',
    configUrl: 'https://lyra-ui-connector.prognplay-ihm.com/api/ui-svc/v1',
    silenceLogsUrl: 'https://lyra-ui-connector.prognplay-ihm.com/api/ui-svc',
    profileUrl: 'https://lyra-ui-connector.prognplay-ihm.com/api/profile/v1',
    redirectUri: window.location.origin,
    clientId: '603ce134-b710-4b4a-b5f7-5c03d7c2b4d2',
    authority: 'https://login.microsoftonline.com/122a527e-5b71-4eba-878d-9810b495b9e3/',
    logoUrlPrefix: 'https://i.iheart.com/v3/re/assets/images',
    usersUrl: null,
    theraptorURL: 'https://api.theraptor.org/getmappings',
    xApiKeyTheRaptor: '0iMOCyAweJ5v46Xk0SWJY6Zu8W8HUxSkargnoJeW',
    maxDownloadTime: 90,
    maxSubscriptionTime: 90,
    defaultSubscriptionTime: 5,
    featureToggle: [
        {
            enabled: true,
            name: 'LINEAR_PLAYOUT_TOGGLE',
            friendlyName: 'Toggle to enable/disable linear playout ',
            jiraCard: 'SIA-3570'
        },
        {
            enabled: true,
            name: 'SUBSCRIPTIONS_TOGGLE',
            friendlyName: 'Toggle to enable/disable Subscriptions ',
            jiraCard: 'SIA-3590'
        },
        {
            enabled: true,
            name: 'AUDIO_SEGMENT_TOGGLE',
            friendlyName: 'Toggle to enable/disable Audio Segment ',
            jiraCard: 'SIA-4413'
        }
    ],
    downloadPaddingInSeconds: 5,
    wavesurferZoom: 2.5,
    orgId : '10J875'

};
